import { createSelector } from 'reselect'
import { selectLocationState } from 'redux-first-router'
import { selectCurrentTicketUndecorated } from 'selectors/tickets/current'
import { selectAgentsSortedByUsername } from 'selectors/agents/base'
import { selectCurrentMailboxId } from 'selectors/mailboxes'
import { selectNewNoteDraftMailboxId } from 'ducks/drafts/selectors/noteDrafts'

const selectAccessLists = state =>
  state.app.accessLists || { widget: {}, mailbox: {} }

export const selectMailboxAccessList = createSelector(
  selectAccessLists,
  accessLists => accessLists.mailbox || {}
)

export const selectWidgetAccessLists = createSelector(
  selectAccessLists,
  accessLists => accessLists.widget || {}
)

export const selectCurrentChannelAccessList = createSelector(
  selectAccessLists,
  selectLocationState,
  selectCurrentTicketUndecorated,
  selectCurrentMailboxId,
  (accessLists, location, ticket, listMailboxId) => {
    if ((location?.query?.channelId || '').startsWith('wid_')) {
      return accessLists.widget[location.query.channelId]
    } else if (ticket?.mailboxId) {
      return accessLists.mailbox[ticket.mailboxId]
    }

    return listMailboxId
  }
)

const selectNewNoteDraftMailboxAccessList = createSelector(
  selectAccessLists,
  selectNewNoteDraftMailboxId,
  (accessLists, mailboxId) => {
    if (!mailboxId) return null
    return accessLists.mailbox[mailboxId]
  }
)

export const selectCurrentMailboxAgents = createSelector(
  selectAgentsSortedByUsername,
  selectCurrentChannelAccessList,
  (agents, accessList) => {
    if (accessList && accessList.agentIds && accessList.agentIds.length > 0) {
      return agents.filter(agent => accessList.agentIds.indexOf(agent.id) > -1)
    }
    return agents
  }
)

export const selectNewNoteDraftMailboxAgents = createSelector(
  selectAgentsSortedByUsername,
  selectNewNoteDraftMailboxAccessList,
  (agents, accessList) => {
    if (accessList && accessList.agentIds && accessList.agentIds.length > 0) {
      return agents.filter(agent => accessList.agentIds.indexOf(agent.id) > -1)
    }
    return agents
  }
)
